import React, { useEffect, useState } from 'react';
import { findIndex } from 'lodash';

import { Input, Select, Checkbox } from 'modules/shared/Forms';
import TitleUndescore from 'modules/shared/TitleUndescore';
import { Peripherals } from 'entities/Peripherals/interfaces';
import { trims } from 'utils';

import styles from '../SettingsSMSCard/SettingsSMSCard.module.scss';

type Props = {
  ordering: any;
  peripherals: Peripherals[] | null;
  onChange: (e: React.ChangeEvent<any>) => void;
};

const OrderingCard: React.FC<Props> = ({ onChange, peripherals, ordering }) => {
  const indexes = {
    ImageScanner: 2,
    FaceID: 4,
  };
  const fieldName = 'ordering.peripheralRoles';
  const [idxImageScanner, setIdxImageScanner] = useState<number>();
  const [idxFaceIDAdd, setIdxFaceIDAdd] = useState<number>();
  const [idxFaceIDAuth, setIdxFaceIDAuth] = useState<number>();

  const findImageScanner = () => findIndex(ordering, (i: any) => i.peripheralHardwareId === indexes.ImageScanner);

  const findFaceIDAdd = () =>
    findIndex(
      ordering,
      (i: any) => i.peripheralHardwareId === indexes.FaceID && trims(i.processName).toLocaleLowerCase() === 'adduser',
    );

  const findFaceIDAuth = () =>
    findIndex(
      ordering,
      (i: any) => i.peripheralHardwareId === indexes.FaceID && trims(i.processName).toLocaleLowerCase() === 'authuser',
    );

  useEffect(() => {
    setIdxImageScanner(findImageScanner());
    setIdxFaceIDAdd(findFaceIDAdd());
    setIdxFaceIDAuth(findFaceIDAuth());
  }, []);

  return (
    <div className="my-5">
      <TitleUndescore title="Виписка" />
      <div className="pl-4 mb-3 col-9">
        <Checkbox
          name="useFaceScan"
          className={styles.checkboxFace}
          label="Додавання Face ID нових водіїв обов'язкове:"
          onChange={onChange}
        />
      </div>
      <div className="pl-4">
        <TitleUndescore title="Сканер документів" className="small" />

        <Select
          name={`${fieldName}[${idxImageScanner}].peripheralHardwareId`}
          label="Модель сканера"
          onChange={onChange}
          className="customSelect mb-2"
        >
          {peripherals
            ? peripherals.map((l: any) => {
                if (l.id !== indexes.ImageScanner) return;

                return (
                  <option key={l.id} value={l.id}>
                    {l.model} ({l.protocol})
                  </option>
                );
              })
            : null}
        </Select>
        <Input
          onChange={onChange}
          label="Точка підключення"
          className="customSelect mb-2"
          isRequiredAtStart
          name={`${fieldName}[${idxImageScanner}].peripheralUrl`}
        />
      </div>

      <div className="pl-4 mb-5">
        <TitleUndescore title="Face ID" className="small" />
        <Select
          name={`${fieldName}[${idxFaceIDAdd}].peripheralHardwareId`}
          label="Модель камери"
          onChange={onChange}
          className="customSelect mb-2"
        >
          {peripherals
            ? peripherals.map((l: any) => {
                if (l.id !== indexes.FaceID) return;

                return (
                  <option key={l.id} value={l.id}>
                    {l.model} ({l.protocol})
                  </option>
                );
              })
            : null}
        </Select>
        <Input
          onChange={onChange}
          label="Точка підключення 'Add User'"
          className="customSelect mb-2"
          isRequiredAtStart
          name={`${fieldName}[${idxFaceIDAdd}].peripheralUrl`}
        />
        <Input
          onChange={onChange}
          label="Точка підключення 'Auth User'"
          className="customSelect mb-2"
          isRequiredAtStart
          name={`${fieldName}[${idxFaceIDAuth}].peripheralUrl`}
        />
        <Input
          onChange={onChange}
          label="Період синхронізації в хвилинах"
          className="customSelect mb-2"
          isRequiredAtStart
          name="syncConfiguration.syncIntervalInMin"
        />
        <Input
          onChange={onChange}
          label="Період збереження водіїв(місяців)"
          className="customSelect mb-2"
          isRequiredAtStart
          name="syncConfiguration.identitySaveInMonths"
        />
      </div>
    </div>
  );
};

export default OrderingCard;
